var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#8DC351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9289 5.92529C11.4924 4.81604 10.3978 4.71592 9.12319 4.96342L8.66925 3.3811L7.70625 3.65729L8.14837 5.19854C7.89525 5.27054 7.63762 5.35042 7.38169 5.42917L6.93731 3.87779L5.97487 4.15342L6.42769 5.73573C6.22069 5.79985 6.01706 5.86285 5.81737 5.92023L5.81569 5.9146L4.48706 6.29542L4.78237 7.32479C4.78237 7.32479 5.49 7.10654 5.48156 7.12342C5.87194 7.01148 6.06375 7.2016 6.15656 7.38667L6.67406 9.18892C6.7005 9.1816 6.73594 9.1726 6.77756 9.16642L6.67575 9.19567L7.39969 11.7213C7.41769 11.849 7.40194 12.0655 7.12969 12.1443C7.14487 12.1516 6.42881 12.3445 6.42881 12.3445L6.56775 13.55L7.821 13.19C8.05444 13.1242 8.28506 13.0623 8.51062 12.9987L8.97019 14.599L9.93206 14.3234L9.47812 12.74C9.73614 12.6715 9.9934 12.6003 10.2499 12.5262L10.701 14.1029L11.6646 13.8267L11.2067 12.2292C12.7991 11.6718 13.8156 10.9389 13.5202 9.37735C13.2829 8.12073 12.5505 7.73935 11.5678 7.7821C12.0448 7.33773 12.2501 6.73642 11.9289 5.92529ZM11.5633 9.73342C11.9064 10.9299 9.81956 11.381 9.16706 11.5689L8.559 9.44823C9.2115 9.26092 11.205 8.48635 11.5627 9.73398L11.5633 9.73342ZM10.2572 6.87029C10.5688 7.95873 8.8245 8.32154 8.28056 8.47735L7.72931 6.55417C8.27269 6.39835 9.9315 5.73573 10.2572 6.87085V6.87029Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBch);
export default __webpack_public_path__ + "static/media/BCH.f515290476763664430211db8c67f9e5.svg";
export { ForwardRef as ReactComponent };